import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Services } from "../components/site/Services";
import { BeforeAfter } from "../components/site/BeforeAfter";
import { Rangement } from "../components/site/Rangement";
import { WhyUs } from "../components/site/WhyUs";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 80);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Rangement />
        <BeforeAfter />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
